export default __webpack_public_path__ + "static/media/doll.95861c05.png";